define('models/composer/forms/VisibilityCondition',[
    'lib/knockout',
    'lib/lodash',
    'util/ObservableModel',
    'enums/composer/visibilityConditionOperation'
], function (ko, _, ObservableModel, visibilityConditionOperation) {
    'use strict';

    var VisibilityConditionModel = ObservableModel.extend({
        defaults: {
            combiningOperation: visibilityConditionOperation.AND,
            predicates: []
        }
    }, function visibilityConditionModel_init() {
        var self = this;

        self.predicates(_.unique(self.predicates()));

        self.addPredicate = function(predicatePath) {
            self.predicates.push(predicatePath || "");
        };

        self.removePredicate = function(predicatePath) {
            // TODO: Broken
            self.predicates.remove(predicatePath);
        };

        if (self.predicates().length === 0) {
            self.addPredicate();
        }

        // Add Knockout-Validation functionality.
        ko.validation.group(self, {deep: true, live: true});
        self.combiningOperation.extend({required: true});

        // Add an unwrap function to remove all unnecessary properties.
        // toIgnore - {object} OR {array}
        //   {object} - An object that maps which properties to ignore based on the type of the model.
        //     The toIgnore key pertaining to this model would be;
        //       'questionGroup': ['properties', 'to', 'ignore']
        //   OR {array} an array of properties to ignore:
        //       ['properties', 'to', 'ignore']
        self.unwrap = function (toIgnore, options) {
            toIgnore = toIgnore || {};
            options = options || {};
            var typeName = "visibilityCondition";
            var ignore = [
                "addPredicate",
                "removePredicate",
                "errors"
            ];
            var passToKids = false;
            if (toIgnore instanceof Array) { // if toIgnore is an array
                ignore = ignore.concat(toIgnore || []);
            } else { // if toIgnore is an object mapping
                ignore = ignore.concat(toIgnore[typeName] || []);
                passToKids = true;
            }
            var data = ObservableModel.unwrap(self, ignore);
            data.predicates = _.map(self.predicates(), function (submodel) {
                return ko.unwrap(submodel);
            });
            return data;
        };
    });

    return VisibilityConditionModel;
});
